<template>
  <v-col>
    <base-card
        height="100%"
        width="100%"
        @click="$router.push({ path: '/video-detail', query: { 'id': value.id } })"
    >
      <v-img
          :src="value.tmpVideoPic"
          height="100%"
          width="100%"
          :max-height="size?380:150"
      >
        <v-row>
          <v-col align-self="start">

            <span class="pack_p_lt" v-if="value.newVideo===1">
              <span class="pack_tag_new">
                NEW
              </span>
            </span>
          </v-col>
          <v-col align-self="center">
          </v-col>
          <v-col align-self="end" class="text-right" v-if="value.privilegeVideo===1">
            <span class="pack_p_rt">
              <span class="pack_tag_vip">
                VIP
              </span>
            </span>


          </v-col>

        </v-row>
      </v-img>
      <v-row
          class="caption pa-3"
      >
        <v-col class="">
          <h2 style="color: white">{{ value.videoName }}</h2>
        </v-col>

      </v-row>

    </base-card>
  </v-col>
</template>

<script>
export default {
  name: 'VideoCard',

  props: {
    size: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style>
.caption {
  color: black;
}

.v-image__image {
  transition: .3s linear;
}

.pack_p_rt {
  border-radius: 0 0 0 7px;
  position: absolute;
  color: #fff;
  font-size: 16px;
  right: 0;
  top: 0;
  padding-left: 5px;
  padding-right: 5px;
  background: #ffdd9a;
}
.pack_p_lt {
  border-radius: 0 0 7px 0px;
  position: absolute;
  color: #fff;
  font-size: 16px;
  left: 0;
  top: 0;
  padding-left: 5px;
  padding-right: 5px;
  background: #ff008c;
}

.pack_tag_vip {
  display: inline-block;
  color: #4e2d03;
}
.pack_tag_new {
  display: inline-block;
  color: #FFFFFF;
}
</style>
